module.exports = __webpack_public_path__ + "img/feature.cd2061e0.webp";